import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUgandaFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8527_36110)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M30.0004 0.000505264C25.7797 -0.00399174 21.6058 0.88467 17.7529 2.6081C13.9001 4.33153 10.4555 6.85072 7.64557 10.0001H52.3527C49.5431 6.85092 46.099 4.33184 42.2466 2.60841C38.3942 0.884986 34.2207 -0.0037817 30.0004 0.000505264Z",
				fill: "#3E4347"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M52.3541 10H7.64555C5.03432 12.9142 3.01895 16.3115 1.7132 20.0002H58.2847C56.9803 16.3113 54.9655 12.9138 52.3541 10Z",
				fill: "#FFE62E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M58.2847 20.0005H1.71312C0.577268 23.212 -0.00208776 26.5939 5.65288e-06 30.0004H60C60.0023 26.5937 59.4222 23.2117 58.2847 20.0005Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60 30.0005H7.21439e-06C-0.00235927 33.4072 0.577487 36.7893 1.71451 40.0007H58.2861C59.4225 36.7892 60.0021 33.4072 60 30.0005Z",
				fill: "#3E4347"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M58.2847 40.0005H1.7132C3.01829 43.6894 5.03373 47.0867 7.64555 50.0004H52.3527C54.9651 47.0872 56.9805 43.6897 58.2847 40.0005Z",
				fill: "#FFE62E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M52.3541 50.0005H7.64557C10.4582 53.1465 13.9032 55.6634 17.7553 57.3867C21.6074 59.1099 25.7798 60.0007 29.9998 60.0007C34.2198 60.0007 38.3923 59.1099 42.2444 57.3867C46.0965 55.6634 49.5415 53.1465 52.3541 50.0005Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.0002 20.0005C31.9781 20.0005 33.9114 20.587 35.5559 21.6859C37.2004 22.7847 38.4821 24.3465 39.2389 26.1738C39.9958 28.0011 40.1938 30.0118 39.8079 31.9516C39.422 33.8914 38.4696 35.6732 37.071 37.0717C35.6725 38.4702 33.8907 39.4226 31.9509 39.8085C30.0111 40.1943 28.0004 39.9962 26.1732 39.2393C24.3459 38.4824 22.7842 37.2007 21.6854 35.5561C20.5866 33.9116 20.0001 31.9782 20.0002 30.0004C20.0002 27.3482 21.0538 24.8047 22.9292 22.9294C24.8046 21.054 27.3481 20.0005 30.0002 20.0005Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.9998 22.0005C29.3954 22.0005 29.782 22.1177 30.1109 22.3375C30.4398 22.5572 30.6962 22.8696 30.8476 23.235C30.9989 23.6004 31.0386 24.0026 30.9614 24.3905C30.8842 24.7785 30.6938 25.1348 30.4141 25.4145C30.1344 25.6942 29.778 25.8847 29.3901 25.9619C29.0021 26.039 28.6 25.9994 28.2346 25.848C27.8691 25.6966 27.5568 25.4403 27.337 25.1114C27.1173 24.7825 27 24.3958 27.0001 24.0002C27.0001 23.4699 27.2109 22.9613 27.5859 22.5863C27.9609 22.2113 28.4695 22.0006 28.9998 22.0005Z",
				fill: "#3E4347"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.4997 33.0005L30.0004 39.0008H30.5003V33.0005H29.4997Z",
				fill: "#3E4347"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.9996 38.5003V39.0003H31.0002V38L28.9996 38.5003Z",
				fill: "#3E4347"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.9282 35.2462C31.8639 33.5755 30.7987 31.9046 29.7329 30.2334C29.3874 29.6903 28.5203 30.1934 28.8683 30.7403C29.772 32.1588 30.6768 33.5788 31.5828 35.0004H28.0012V35.5004C29.671 35.5004 30.8247 36.0004 32.4973 36.0004C32.5849 35.999 32.6707 35.9748 32.7461 35.9302C32.8215 35.8856 32.8841 35.8221 32.9276 35.746C32.971 35.6699 32.9939 35.5838 32.9941 35.4962C32.9942 35.4086 32.9715 35.3224 32.9282 35.2462Z",
				fill: "#3E4347"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31.9281 30.0985C30.7907 29.6807 28.5682 29.2175 30.0002 25.0005H28.1758C28.1758 25.0005 23.799 33.7276 31.9281 33.7276C33.7247 33.7276 34.5058 35.1824 34.5058 37.0007C34.5058 37.0007 36.672 31.8447 31.9281 30.0985Z",
				fill: "#3E4347"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.5002 34.5005L28.0001 36.5007H28.4997V34.5005H27.5002Z",
				fill: "#3E4347"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.9996 23.0005L25.0003 25.0004H28.9996V23.0005Z",
				fill: "#3E4347"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.9999 30.6172V33.943C32.9999 33.943 34.5938 34.5931 33.9381 37.0005L34.9997 37.5316C34.9997 37.5316 36.8443 32.7343 32.9999 30.6172Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.4997 30.0005C29.4997 30.0005 29.4983 32.5846 32.0408 32.5846C32.0408 32.5846 33 30.0005 29.4997 30.0005Z",
				fill: "#94989B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.3587 28.189C28.8329 28.189 29.2178 28.8835 29.2178 29.7409C29.2178 30.5977 28.8329 31.2928 28.3587 31.2928C27.8845 31.2928 27.4999 30.5977 27.4999 29.7409C27.4999 28.8835 27.8845 28.189 28.3587 28.189Z",
				fill: "#94989B"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8527_36110",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 60,
			height: 60,
			fill: "white",
			transform: "translate(0 0.000488281)"
		})
	}) })]
});
export default SvgUgandaFlag;
